import { CheckboxGroup } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceCheckboxGroup",
  //extends: CheckboxGroup,
  mixins: [CheckboxGroup, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    groupDisabled() {
      return this.isOperationDisabled() || !this.isAuth;
    },
  },
};
